module.exports = __webpack_public_path__ + "img/gjaq.7b40f516.png";